import { defineMessages } from 'react-intl';

export default defineMessages({
	appleTV: {
		id: 'svod.appleTV',
		defaultMessage: "Apple TV+",
	},
	prime_video: {
		id: 'svod.prime_video',
		defaultMessage: "Prime Video",
	},

	welcome_to_peacock: {
		id: 'svod.welcome_to_peacock',
		defaultMessage: "Welcome to Peacock",
	},

	play_upper: {
		id: 'svod.play_upper',
		defaultMessage: "PLAY",
	},
	play: {
		id: 'svod.play',
		defaultMessage: "Play",
	},
	skip_intro: {
		id: 'svod.skip_intro',
		defaultMessage: "Skip Intro",
	},
	resume_episode: {
		id: 'svod.resume_episode',
		defaultMessage: "Resume Episode",
	},
	play_first_episode: {
		id: 'svod.play_first_episode',
		defaultMessage: "Play First Episode",
	},
	subtitles_upper: {
		id: 'svod.subtitles_upper',
		defaultMessage: "SUBTITLES",
	},
	audio_track_upper: {
		id: 'svod.audio_track_upper',
		defaultMessage: "AUDIO TRACK",
	},
	from_beginning: {
		id: 'svod.from_beginning',
		defaultMessage: "From Beginning",
	},
	more_episodes: {
		id: 'svod.more_episodes',
		defaultMessage: "More Episodes",
	},
	more_info: {
		id: 'svod.more_info',
		defaultMessage: "More Info",
	},
	info: {
		id: 'svod.info',
		defaultMessage: "Info",
	},
	view_all: {
		id: 'svod.view_all',
		defaultMessage: "View All",
	},
	no_row_selected: {
		id: 'svod.no_row_selected',
		defaultMessage: "No row selected",
	},
	submit_upper: {
		id: 'svod.submit_upper',
		defaultMessage: "SUBMIT",
	},
	watch_now: {
		id: 'svod.watch_now',
		defaultMessage: "Watch Now",
	},
	my_stuff: {
		id: 'svod.my_stuff',
		defaultMessage: "My Stuff",
	},
	home: {
		id: 'svod.home',
		defaultMessage: "Home",
	},
	browse: {
		id: 'svod.browse',
		defaultMessage: "Browse",
	},
	featured: {
		id: 'svod.featured',
		defaultMessage: "Featured",
	},
	tv_shows: {
		id: 'svod.tv_shows',
		defaultMessage: "TV Shows",
	},
	movies: {
		id: 'svod.movies',
		defaultMessage: "Movies",
	},
	sports: {
		id: 'svod.sports',
		defaultMessage: "Sports",
	},
	wwe: {
		id: 'svod.wwe',
		defaultMessage: "WWE",
	},
	kids: {
		id: 'svod.kids',
		defaultMessage: "Kids",
	},
	news: {
		id: 'svod.news',
		defaultMessage: "News",
	},
	latino: {
		id: 'svod.latino',
		defaultMessage: "Latino",
	},
	library: {
		id: 'svod.library',
		defaultMessage: "Library",
	},
	store: {
		id: 'svod.store',
		defaultMessage: "Store",
	},
	please_watch_the_episode: {
		id: 'svod.please_watch_the_episode',
		defaultMessage: "Please watch the episode",
	},
	not_available: {
		id: 'svod.not_available',
		defaultMessage: "Not Available",
	},
	log_out: {
		id: 'svod.log_out',
		defaultMessage: "Log Out",
	},

	watchlist: {
		id: 'svod.watchlist',
		defaultMessage: "Watchlist",
	},
	added_to_watchlist: {
		id: 'svod.added_to_watchlist',
		defaultMessage: "Added!",
	},
	removed_from_watchlist: {
		id: 'svod.removed_from_watchlist',
		defaultMessage: "Removed from watchlist",
	},
	no_items_added: {
		id: 'svod.no_items_added',
		defaultMessage: "No Items Added!",
	},
	my_list: {
		id: 'svod.my_list',
		defaultMessage: "My List",
	},
	in_next_up: {
		id: 'svod.in_next_up',
		defaultMessage: "In Next Up()",
	},
	add_to_up_next: {
		id: 'svod.add_to_up_next',
		defaultMessage: "Add to Up Next",
	},
	first_to_leave_comment: {
		id: 'svod.first_to_leave_comment',
		defaultMessage: "Be the first to leave a comment!",
	},
	thank_you_for_comment: {
		id: 'svod.thank_you_for_comment',
		defaultMessage: "Thank you for your comment!",
	},
	join_the_conversation: {
		id: 'svod.join_the_conversation',
		defaultMessage: "Join the Conversation",
	},
	write_comment_or_review: {
		id: 'svod.write_comment',
		defaultMessage: "Write your comment or review",
	},
	leave_a_comment_and_rating: {
		id: 'svod.leave_a_comment_and_rating',
		defaultMessage: "Please leave a comment and a rating.",
	},
	write_review: {
		id: 'svod.write_review',
		defaultMessage: "Write a customer review",
	},
	rate_video: {
		id: 'svod.rate_video',
		defaultMessage: "Rate Video",
	},
	your_name_optional: {
		id: 'svod.your_name_optional',
		defaultMessage: "Your Name (optional)",
	},

	free_content: {
		id: 'svod.free_content',
		defaultMessage: "Free Content",
	},

	more_like_this: {
		id: 'svod.more_like_this',
		defaultMessage: "More Like This",
	},
	watch_latest_episode: {
		id: 'svod.watch_latest_episode',
		defaultMessage: "Watch Latest Episode",
	},
	episode: {
		id: 'svod.episode',
		defaultMessage: "Episode",
	},
	episodes: {
		id: 'svod.episodes',
		defaultMessage: "Episodes",
	},
	season: {
		id: 'svod.season',
		defaultMessage: "Season",
	},
	seasons: {
		id: 'svod.seasons',
		defaultMessage: "Seasons",
	},
	season_initial: {
		id: 'svod.season_initial',
		defaultMessage: "S",
	},
	episode_initial: {
		id: 'svod.episode_initial',
		defaultMessage: "E",
	},
	length: {
		id: 'svod.length',
		defaultMessage: "Length",
	},
	rating: {
		id: 'svod.rating',
		defaultMessage: "Rating",
	},
	genres: {
		id: 'svod.genres',
		defaultMessage: "Genres",
	},
	maturity_ratings: {
		id: 'svod.maturity_ratings',
		defaultMessage: "Maturity Ratings",
	},
	reviews: {
		id: 'svod.reviews',
		defaultMessage: "Reviews",
	},
	overview_upper: {
		id: 'svod.overview_upper',
		defaultMessage: "OVERVIEW",
	},
	comments_reviews_upper: {
		id: 'svod.comments_reviews_upper',
		defaultMessage: "COMMENTS & REVIEWS",
	},
	details_upper: {
		id: 'svod.details_upper',
		defaultMessage: "DETAILS",
	},
	details: {
		id: 'svod.details',
		defaultMessage: "Details",
	},
	trailers: {
		id: 'svod.trailers',
		defaultMessage: "Trailers",
	},
	related: {
		id: 'svod.related',
		defaultMessage: "Related",
	},
	about: {
		id: 'svod.about',
		defaultMessage: "About",
	},
	information: {
		id: 'svod.information',
		defaultMessage: "Information",
	},
	released: {
		id: 'svod.released',
		defaultMessage: "Released",
	},
	rated: {
		id: 'svod.rated',
		defaultMessage: "Rated",
	},
	languages: {
		id: 'svod.languages',
		defaultMessage: "Languages",
	},
	starring: {
		id: 'svod.starring',
		defaultMessage: "Starring",
	},
	primary: {
		id: 'svod.primary',
		defaultMessage: "Primary",
	},
	english: {
		id: 'svod.english',
		defaultMessage: "English",
	},
	additional: {
		id: 'svod.additional',
		defaultMessage: "Additional",
	},
	other_available_languages: {
		id: 'svod.other_available_languages',
		defaultMessage: "other available languages",
	},
	accessibility: {
		id: 'svod.accessibility',
		defaultMessage: "Accessibility",
	},
	sdh_description: {
		id: 'svod.sdh_description',
		defaultMessage: "Subtitles for the deaf and hard of hearing (SDH) refer to subtitles in the original language.",
	},
	ad_description: {
		id: 'svod.ad_description',
		defaultMessage: "Audio descriptions (AD) refer to a narration track describing what is happening on the screen.",
	},

	cc: {
		id: 'svod.cc',
		defaultMessage: "CC",
	},
	sdh: {
		id: 'svod.sdh',
		defaultMessage: "SDH",
	},
	ad: {
		id: 'svod.ad',
		defaultMessage: "AD",
	},

	terms_of_use: {
		id: 'svod.terms_of_use',
		defaultMessage: "Terms of Use",
	},
	privacy_policy: {
		id: 'svod.privacy_policy',
		defaultMessage: "Privacy Policy",
	},
	ad_choices: {
		id: 'svod.ad_choices',
		defaultMessage: "Ad Choices",
	},
	help: {
		id: 'svod.help',
		defaultMessage: "Help",
	},
	do_not_sell_my_personal_information: {
		id: 'svod.do_not_sell_my_personal_information',
		defaultMessage: "Do Not Sell My Personal Information",
	},
	ca_notice: {
		id: 'svod.ca_notice',
		defaultMessage: "CA Notice",
	},
	pilotly_simulator: {
		id: 'svod.pilotly_simulator',
		defaultMessage: "Pilotly Simulator",
	},

});



// WEBPACK FOOTER //
// ./src/locales/svod.js